<template>
  <RevCard class="p-24">
    <div class="mb-24 flex flex-wrap items-center justify-between gap-8">
      <div class="heading-2 flex items-center gap-8">
        <IconListView1 />
        {{ i18n(translations.taskList) }}
      </div>

      <div class="flex">
        <ClientOnly>
          <div class="flex items-center gap-8" data-allow-mismatch>
            <IconCalendar />
            {{ i18n.date(new Date(), { dateStyle: 'full' }) }}
          </div>
        </ClientOnly>
      </div>
    </div>

    <div>
      <RevLoadingScreen
        v-if="isLoading"
        class="mt-32"
        :text="i18n(translations.loading)"
      />

      <RevList v-else :has-external-borders="false">
        <div
          v-for="task in tasks"
          :key="task.message"
          :class="{ 'bg-static-danger-mid': task.type === 'ERROR' }"
        >
          <RevListItemInteractive :to="task.link">
            <template #label> {{ task.message }} </template>
            <template #suffix> <IconChevronRight /> </template>
          </RevListItemInteractive>
        </div>

        <div v-if="!tasks?.length" class="pt-32">
          {{ i18n(translations.noTasks) }}
        </div>
      </RevList>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { type Error, getApiErrorMessage } from '#imports'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevCard } from '@ds/components/Card'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { IconCalendar } from '@ds/icons/IconCalendar'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconListView1 } from '@ds/icons/IconListView1'

import translations from './TaskList.translations'

const i18n = useI18n()
const { openErrorToast } = useTheToast()

const {
  data: tasks,
  error,
  pending: isLoading,
} = await useHttpFetch(merchantsAPI.getHomepageMessages)

if (error.value) {
  openErrorToast({
    content: getApiErrorMessage(error.value as unknown as Error),
  })
}
</script>
